import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { PATH } from 'app/constants/path';
import { generatePathWithQuery } from 'app/utils/generate-path-with-query';

interface Props {
  isAuthenticated: boolean;
}

export const RootRedirect: React.FC<Props> = ({ isAuthenticated }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const queryParams = Object.fromEntries(searchParams.entries());
  
  const targetPath = isAuthenticated ? PATH.NEWS_PAGE : PATH.LOGIN_PAGE;
  const redirectPath = generatePathWithQuery(
    targetPath, 
    undefined, 
    Object.keys(queryParams).length > 0 ? queryParams : undefined
  );
  
  return <Navigate to={redirectPath} replace />;
};